export default {"src":"/_next/static/media/rotate.e1656548.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};